import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { CountryService } from '../proxy/planning/controllers/country.service';
import { StorageLocationService } from '@controlling/proxy/controlling/controllers/storage-location.service'
import { LocationService } from '../proxy/planning/controllers/location.service';

FieldBuilder.setNamespace('Planning');

export const REGION_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Region.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.Region.Code')
    .maxLength(10)
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('storageLocationId', 'Entity.StorageLocation', StorageLocationService)
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder
    .foreignKey('countryId', 'Entity.Country', CountryService)
    .displayFromNested('country.name')
    .sortBy('country.name')
    .build(),
  FieldBuilder
    .foreignKey('locationId', 'Entity.Location', LocationService)
    .required()
    .displayFromNested('location.name')
    .sortBy('location.name')
    .hideInChildForms()
    .build(),
];

export const REGION_CONFIG = {
  entityName: 'Region',
  localizationKey: 'Planning::Entity.Region',
  fields: REGION_FIELDS,
  permission: 'PlanningLocation.Regions',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Location + MENU_NAME_SUFFIX,
};
